module.exports = new __parcel__URL__("here-wallet-icon.3b7fb3a5.png").toString();